import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import axios from '../../axios'
import { toast } from 'react-toastify';
import Sector from '../Dropdowns/Sector';
import Scheme from '../Dropdowns/Scheme';
import Batch from '../Dropdowns/Batch';
import SmartTc from '../Dropdowns/SmartTC';
import Centre from '../Dropdowns/Centre';
import UserTypeDropdown from "../Dropdowns/UserTypesDropdown";
export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) 
{
    const {invoice_id,
            invoice_no,
            milestone,
            gross_amount,
            tds_amount,
            penal_deduction,
            created_date,
            net_payment,
            status,
            received_date,
            kit,
            book,
            centre_share,
            tds,
            centre_id,
            scheme_id,
            batch_id
        
     } = updateProductData;
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const [batch, setBatch] = useState(batch_id);
  const [centre, setCentre] = useState(centre_id);
  const [scheme, setScheme] = useState(scheme_id);
  const[imilestone,setMilestone]=useState(milestone)
  const[istatus,setStatus]=useState(status)
  const [smart, setSmart] = useState(centre_id);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const [invoice, setInvoice] = useState({
    invoice_no:invoice_no,
    gross_amount: gross_amount,
    tds_amount: tds_amount,
    penal_deduction: penal_deduction,
    created_date: formatDate(created_date),
    net_payment: net_payment,
    status: status,
    received_date: formatDate(received_date),
    kit: kit,
    book: book,
    centre_share: centre_share,
    tds: tds
  });

const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoice(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

const dont=true

  const updateProduct = () => {
    axios.put(`/invoice/update/${invoice_id}`,{
      invoice_no: invoice.invoice_no,
        milestone: imilestone,
        gross_amount: invoice.gross_amount,
        tds_amount: invoice.tds_amount,
        penal_deduction: invoice.penal_deduction,
        created_date: formatDate(invoice.created_date),
        net_payment: invoice.net_payment,
        status: istatus,
        received_date: formatDate(invoice.received_date),
        kit: invoice.kit,
        book: invoice.book,
        centre_share: invoice.centre_share,
        tds: invoice.tds,
        batch_id:batch,
        scheme_id:scheme,
        centre_id:centre,
        smart_tc_id:smart
      }
      )
      .then((response) => {
        
       
          toast.success("Invoice Updated")
        updateModalSetting();
     
      })
      .catch((error) => {
        if(error.response.data.error){
          toast.error(error.response.data.error)
        }
        console.error('something went wrong',error)});
      handlePageUpdate()
  }
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Invoice
                      </Dialog.Title>
                      <form action="#">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
                        <div>
                            <label htmlFor="invoice_no" className="block text-sm font-medium mb-2 text-gray-700">Invoice Number</label>
                            <input type="text"
                             name="invoice_no"
                              id="invoice_no" 
                             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                             
                               value={invoice.invoice_no} 
                               onChange={handleInputChange} />
  </div>
  <div>
    <Centre value={centre} handleInputChange={(e)=>setCentre(e.target.value)} dont={dont}/>
  </div>
  <div>
    <SmartTc value={centre} handleInputChange={e=>setCentre(e.target.value)} dont={dont}/>
  </div>
  <div>
    <Batch value={batch} handleInputChange={(e)=>setBatch(e.target.value)} dont={dont}/>
  </div>
  <div>
    <Scheme value={scheme} handleInputChange={(e)=>setScheme(e.target.value)}  centre={centre} dont={dont}/>
  </div>
  <div>
    <label htmlFor="milestone"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
      Milestone</label>
      <select
                id="milestone"
                value={imilestone}
                onChange={e=>setMilestone(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' >--Select--</option>
                <option value="Installment 1">Installment 1</option>
                <option value="Installment 2">Installment 2</option>
                <option value="Installment 3">Installment 3</option>
                <option value='Installment 4'>Installment 4</option>
                


            </select>
  </div>
  <div>
    <label htmlFor="status"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Status</label>
    <select
                id="status"
                value={istatus}
                onChange={e=>setStatus(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   
                >
                <option value='' >--Select--</option>
                <option value="Invoice Raised">Invoice Raised</option>
                <option value="Invoice Paid">Invoice Paid</option>
                <option value="Invoice Unpaid">Invoice Unpaid</option>
                


            </select>
  </div>
  <div>
                              <label htmlFor="created_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Created Date</label>
                            <input
                            type="date"
                            id="created_date"
                            name="created_date"
                            value={invoice.created_date}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="received_date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Received Date</label>
                            <input
                            type="date"
                            id="received_date"

                            name="received_date"
                            value={invoice.received_date}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"   

                            onChange={handleInputChange}
                            />

                            </div>
  

  <div>
    
    <label htmlFor="gross_amount" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Gross Amount</label>
    <input type="text" name="gross_amount"  id="gross_amount"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.gross_amount} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="tds_amount"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">TDS Amount</label>
    <input type="text" name="tds_amount" id="tds_amount"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.tds_amount} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="penal_deduction"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Penal Deduction</label>
    <input type="text" name="penal_deduction" id="penal_deduction"                                  
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.penal_deduction} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="net_payment"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Net Payment</label>
    <input type="text" name="net_payment" id="net_payment"                                   
    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.net_payment} onChange={handleInputChange} />
  </div>

  <div>
  <label htmlFor="book"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Book</label>
    <input type="text" name="book" id="book"                                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.book} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="kit"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Kit</label>
    <input type="text" name="kit" id="kit"                                  
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.kit} onChange={handleInputChange} />
  </div>
  <div>
    <label htmlFor="centre_share"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Centre Share</label>
    <input type="text" name="centre_share" id="centre_share"                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.centre_share} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="tds"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
    Centre TDS</label>
    <input type="text" name="tds" id="tds"                                 
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
value={invoice.tds} onChange={handleInputChange} />
  </div>
  <div>
  <label htmlFor="tds"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">After TDS</label>
    <input type="text" name="tds" id="tds"                                  
     className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
 value={invoice.centre_share - invoice.tds} />
  </div>
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                  Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
